export class Card {
    temporary_token: string;
    masked_card_number: string;
    expiry_month: number;
    expiry_year: number;
    type: string;
}
